<ng-container *ngIf="date; else isDateNull">
  {{ date | date : 'MM/dd/yyyy' }}
</ng-container>
<ng-template #isDateNull></ng-template>
